export const protocolizeUrl = (url: string | undefined): string | undefined =>
  !url
    ? url
    : url.startsWith('https://') ||
      url.startsWith('http://') ||
      url.startsWith('mailto:') ||
      url.startsWith('tel:')
    ? url
    : 'https://' + url;
